import { PauseCircle, SkipForward, Repeat, XCircle, CreditCard, Mail } from "lucide-react";
import { PageHero, Section, SectionHeading, Seo, Reveal, breadcrumb } from "@/components/site/Section";
import { HowItWorksSteps } from "@/components/site/Hero";
import { FinalCTA } from "@/components/site/HomeSections";

const CONTROLS = [
  { icon: PauseCircle, t: "Pause", d: "Take a break for 1, 2 or 3 months. No charges or deliveries while paused, and it resumes automatically." },
  { icon: SkipForward, t: "Skip", d: "Skip your next delivery. You won't be charged for it, and your dates move on together." },
  { icon: Repeat, t: "Change plan", d: "Move between Starter, Regular and Family. We show the new price and start date before you confirm." },
  { icon: XCircle, t: "Cancel", d: "Cancel online in a few clicks. No phone calls, no emails, no awkward conversations." },
];

const BILLING = [
  { icon: CreditCard, t: "Simple monthly billing", d: "Your first payment is taken when you subscribe. After that, you're billed monthly on the same date until you pause or cancel." },
  { icon: Mail, t: "Always kept in the loop", d: "We email you to confirm your subscription, payments, upcoming deliveries and any changes you make." },
];

export default function HowItWorksPage() {
  return (
    <>
      <Seo title="How Our Firewood Subscription Works" path="/how-it-works" jsonLd={breadcrumb("How It Works", "/how-it-works")} description="How the WeeLogRun log membership works: choose a plan, tell us where to deliver, and enjoy monthly log deliveries." />
      <PageHero eyebrow="How it works" title="Firewood, on autopilot." intro="Sign up in minutes, then let us take care of the logs. You stay in control from your My WeeLogRun account." image="/img/room-stove.jpg" />
      <HowItWorksSteps withHeading={false} />
      <Section className="bg-[#0b0b0b]">
        <SectionHeading eyebrow="You're in control" title="Manage everything online." intro="Life changes. Your firewood plan should too." />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CONTROLS.map(({ icon: Icon, t, d }, i) => (
            <Reveal key={t} delay={i * 0.08}>
              <div className="h-full rounded-3xl border border-[#262626] bg-[#111] p-7">
                <Icon className="h-7 w-7 text-[#FF6A00]" />
                <h3 className="mt-6 font-display text-xl font-semibold">{t}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#A1A1AA]">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
      <Section>
        <div className="grid gap-6 md:grid-cols-2">
          {BILLING.map(({ icon: Icon, t, d }) => (
            <Reveal key={t}>
              <div className="flex gap-5 rounded-3xl border border-[#262626] p-7">
                <Icon className="h-7 w-7 shrink-0 text-[#D4A437]" />
                <div>
                  <h3 className="font-display text-xl font-semibold">{t}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-[#A1A1AA]">{d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
      <FinalCTA />
    </>
  );
}
